/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { core_Asset } from './core_Asset';
export type b2b_v1_portfolio_builder_asset_list_CreateAssetList = {
    assets?: Array<core_Asset>;
    name: string;
    organization: string;
    type?: b2b_v1_portfolio_builder_asset_list_CreateAssetList.type;
};
export namespace b2b_v1_portfolio_builder_asset_list_CreateAssetList {
    export enum type {
        PORTFOLIO_BUILDER = 'portfolio_builder',
        ASSET_CLASS = 'asset_class',
    }
}

